import axios from 'axios'
import router from 'vue-router'
import {
    getToken,
    setToken
} from '@/utils/auth'
import Vue from 'vue'
Vue.use(router)

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // do something before request is sent

        config.headers['x-token'] = getToken()
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(

    response => {
        const res = response.data

        // if the custom code is not 200, it is judged as an error.
        if (res.state !== 200) {

            // return Promise.reject(new Error(res.msg || 'Error'))
            // Vue.router.replace('/sign')
            // if(response.config.url == '/index/user/checkToken') {
            //     Vue.router.replace('/index')
            // }
            console.log(res.msg);
            if(res.msg=='请登录获取有效的授权信息') {
                console.log(this);
                Vue.router.replace('/index')
            }else {
                return Promise.reject(res)
            }
            
        } else {
            if(response.headers['x-token']) {
                setToken(response.headers['x-token'])
            }
            
            return res
        }
    },
    error => {
        console.log('err' + error) // for debug
        console.log(error.msg);
        return Promise.reject(error)
    }
)

export default service